import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Tutorial } from "./Tutorial";
import Model from "./Model";
export class Category extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'category_id',
      fieldTitle: 'Category id',
      content: null
    });
    _defineProperty(this, "CategoryId", {
      fieldName: 'category_id',
      fieldTitle: 'Category id',
      content: null
    });
    _defineProperty(this, "CategoryName", {
      fieldName: 'category_name',
      fieldTitle: 'Category name',
      content: null
    });
    _defineProperty(this, "CategoryState", {
      fieldName: 'category_state',
      fieldTitle: 'Category state',
      content: 0
    });
    _defineProperty(this, "CategoryTutorials", {
      fieldName: 'category_tutorials',
      fieldTitle: 'Category tutorials',
      model: Tutorial,
      content: []
    });
    _defineProperty(this, "publishLoading", {
      content: false
    });
    _defineProperty(this, "loading", {
      content: false
    });
  }
  isLoading() {
    return this.loading.content;
  }
  startLoading() {
    this.loading.content = true;
    return this;
  }
  endLoading() {
    this.loading.content = false;
    return this;
  }
  startPublishLoading() {
    this.publishLoading.content = true;
    return this;
  }
  endPublishLoading() {
    this.publishLoading.content = false;
    return this;
  }
  isPublishLoading() {
    return this.publishLoading.content;
  }
  getId() {
    return this.Id.content;
  }
  getTutorials() {
    return this.CategoryTutorials.content;
  }
  getName() {
    return this.CategoryName.content;
  }
  isPublished() {
    return this.CategoryState.content;
  }
}
export default Category;